import createRemoteArrayResourceReducer from "./helpers/createRemoteArrayResourceReducer";
import createRemoteObjectResourceReducer from "./helpers/createRemoteObjectResourceReducer";

export const entitlementCategories = createRemoteObjectResourceReducer("ENTITLEMENT_CATEGORIES");
export const permissionsList = createRemoteArrayResourceReducer("PERMISSIONS_LIST");
export const postPermissions = createRemoteObjectResourceReducer("PERMISSIONS");
export const deletePermissions = createRemoteObjectResourceReducer("REMOVE_PERMISSIONS");
export const existingEmailLists = createRemoteArrayResourceReducer("EXISTING_EMAIL_LISTS");
export const enrollmentStatus = createRemoteArrayResourceReducer("ENROLLMENT_STATUS");
